import {InAppNotificationAction} from "../../../types/notificationType";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {ActionModule} from "../../../types/actionModule/actionModule";
import {Autocomplete, CircularProgress, Stack, TextField, Typography} from "@mui/material";
import {actionModulesApi} from "../../../api/actionsModulesApi";
import {useAppDispatch} from "../../../hooks/StoreHooks";
import {handleRequest} from "../../../store/utils/handleRequest";

interface Props {
    action: InAppNotificationAction;
    onChange: (action: InAppNotificationAction) => void;
    isCompanyWideAssigned: boolean;
    groupIds: number[];
    employeeUserIds: string[];
}

export default function ActionModuleReferenceField({
                                                       action,
                                                       onChange,
                                                       isCompanyWideAssigned,
                                                       groupIds,
                                                       employeeUserIds,
                                                   }: Props) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [modules, setModules] = useState<ActionModule[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchModules = async () => {
            setIsLoading(true);
            const result = await handleRequest(
                dispatch,
                "indirect",
                () => actionModulesApi.getActionsFilteredByVisibility(isCompanyWideAssigned, groupIds, employeeUserIds)
            );
            if (result.success()) {
                const fetched = result.result ?? [];
                setModules(fetched);
                if (action.reference && !fetched.some(m => String(m.id) === action.reference)) {
                    onChange({ ...action, reference: undefined });
                }
            }
            setIsLoading(false);
        };
        void fetchModules();
    }, [isCompanyWideAssigned, groupIds, employeeUserIds, dispatch]);
    const selectedModule = modules.find(m => String(m.id) === action.reference) ?? null;

    return (
        <Autocomplete
            options={modules}
            loading={isLoading}
            value={selectedModule}
            getOptionLabel={(m) => m.name ?? String(m.id)}
            onChange={(_, selected) => onChange({
                ...action,
                reference: selected ? String(selected.id) : undefined
            })}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t("genericInAppNotificationsPage.action.reference.actionModule")}
                    slotProps={{
                        ...params.slotProps,
                        input: {
                            ...params.slotProps.input,
                            endAdornment: (
                                <>
                                    {isLoading && <CircularProgress size={18} />}
                                    {params.slotProps.input?.endAdornment}
                                </>
                            ),
                        },
                    }}
                />
            )}
        />
    )

}